<app-breadcrumbs class="mb-3" [lastLabel]="(name ?? '')"></app-breadcrumbs>

<mat-card class="mat-elevation-z8 container-card">
    <mat-card-content class="mat-elevation-z8">
        <div class="form-container">
                    <form [formGroup]="formDataProfile" (ngSubmit)="onSubmitProfileData()" class="p-4 form--underline form-profile">

                        <div class="form-section">
                            <div class="pair-grid">

                                <mat-form-field appearance="fill" class="readonly" subscriptSizing="dynamic">
                                    <mat-label>Nome</mat-label>
                                    <input matInput type="text" formControlName="firstName" readonly aria-readonly="true" />
                                    <mat-icon matSuffix class="suffix-readonly" aria-hidden="true">lock</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="readonly" subscriptSizing="dynamic">
                                    <mat-label>Cognome</mat-label>
                                    <input matInput type="text" formControlName="lastName" readonly aria-readonly="true" />
                                    <mat-icon matSuffix class="suffix-readonly" aria-hidden="true">lock</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="readonly" subscriptSizing="dynamic">
                                    <mat-label>Email</mat-label>
                                    <input matInput type="text" formControlName="email" readonly aria-readonly="true" />
                                    <mat-icon matSuffix class="suffix-readonly" aria-hidden="true">lock</mat-icon>
                                </mat-form-field>

                                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                                    <mat-label>Password</mat-label>
                                    <input matInput type="text" formControlName="password" />
                                </mat-form-field>
                                <ng-container *ngIf="!isViewer(); else readonlyView">
                                    <!-- Select per ADMIN -->
                                    <mat-form-field appearance="fill" subscriptSizing="dynamic">
                                        <mat-label>Ruolo</mat-label>
                                        <mat-select formControlName="role">
                                            <mat-option *ngFor="let opt of roleSelectOptions" [value]="opt.value">
                                                {{opt.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <!-- Input readonly per VIEWER -->
                                 <ng-template #readonlyView>
                                    <mat-form-field appearance="fill" class="readonly" subscriptSizing="dynamic">
                                        <mat-label>Ruolo</mat-label>
                                        <input matInput type="text" formControlName="role" readonly aria-readonly="true" />
                                        <mat-icon matSuffix class="suffix-readonly" aria-hidden="true">lock</mat-icon>
                                    </mat-form-field>
                                 </ng-template>
                                
                            </div>
                        </div>

                        <div class="actions">
                            <button type="submit" class="btn btn-primary my-3" mat-raised-button [disabled]="(formDataProfile.invalid && formDataProfile.touched) || isLoading">
                        Salva
                      </button>
                        </div>

                        <app-loading [showLoading]="isLoading"></app-loading>
                    </form>
            </div>
    </mat-card-content>
</mat-card>
